import { apiGet, apiPatch, apiPost } from './client';
import type {
  SpecialRate,
  SpecialRateBatchRequest,
  SpecialRateRangeRequest,
} from '../types/SpecialRate';

// Central (general) special rates — not tenant-scoped.
export function getSpecialRatesGeneral(): Promise<SpecialRate[]> {
  return apiGet<SpecialRate[]>('/api/special-rates-general');
}

export function saveSpecialRatesGeneralBatch(
  added: SpecialRate[],
  modified: SpecialRate[],
  deletedIds: number[],
): Promise<SpecialRate[]> {
  return apiPatch<SpecialRateBatchRequest, SpecialRate[]>(
    '/api/special-rates-general/batch',
    { added, modified, deleted: deletedIds },
  );
}

export function addSpecialRatesGeneralRange(
  req: SpecialRateRangeRequest,
): Promise<SpecialRate[]> {
  return apiPost<SpecialRateRangeRequest, SpecialRate[]>(
    '/api/special-rates-general/range',
    req,
  );
}
